import React, { Component } from 'react';
import { List, ListItem, Box } from '@mui/material';
import PortalTooltip from '../../common/PortalTooltip';
import PortalLink from '../../common/PortalLink';

class ProgramResources extends Component {
  render() {
    return (
      <List sx={{ py: 0 }} dense={true}>
        {this.props.myProgramLinks.map((item, index) => {
          return (
            <ListItem
              sx={{ pl: 1 }}
              id={this.props.id + '__programResources_' + index}
              key={this.props.id + '__programResources_' + index}
              divider
            >
              <PortalLink
                target={item.target}
                href={item.link}
                underline={'hover'}
                className="noIcon"
              >
                {item.title}
              </PortalLink>
            </ListItem>
          );
        })}
      </List>
    );
  }
}

export default ProgramResources;
